import React from "react";
import { Typography } from "@mui/material";
import { useTailwindBrand } from "../../shared";
import { describeMonthlyQuota, monthlyQuotaOf } from "../../../Utils/monthlyQuota";

interface MonthlyQuotaCellProps {
    /** coursesThisRollingMonth : tous prestataires confondus. */
    total: number | null | undefined;
    /** coursesMonthByThisTeachr : le prof connecté. */
    mine: number | null | undefined;
}

const TONE_COLORS = {
    default: { headline: "text.primary", detail: "text.secondary" },
    warning: { headline: "warning.main", detail: "warning.main" },
    danger: { headline: "error.main", detail: "error.main" },
};

/**
 * Cellule « cours du mois » des tableaux (liste des clients, choix de l'élève
 * à la déclaration) : ce qu'il reste au client sur 8, puis « dont x par vous ».
 */
const MonthlyQuotaCell: React.FC<MonthlyQuotaCellProps> = ({ total, mine }) => {
    const { brandConfig } = useTailwindBrand();
    const text = describeMonthlyQuota(monthlyQuotaOf(total, mine), { compact: true });
    const colors = TONE_COLORS[text.tone];
    return (
        <>
            <Typography variant="body2" fontWeight={700} sx={{ fontFamily: brandConfig.fontFamily, color: colors.headline }}>
                {text.headline}
            </Typography>
            <Typography variant="caption" sx={{ fontFamily: brandConfig.fontFamily, whiteSpace: "nowrap", color: colors.detail }}>
                {text.detail}
            </Typography>
        </>
    );
};

export default MonthlyQuotaCell;
